import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    margin: 'auto',
  },
  logoLink: {
    maxHeight: 30
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 52,
    boxSizing: 'border-box',
    padding: theme.spacing(0, 2),
    backgroundColor: 'white',
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 4,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.up('lg')]: {
      margin: 'auto',
      maxWidth: '90vw',
    },
  },
  slogan: {
    position: 'relative',
    fontFamily: '"Exo 2", Sans-serif',
    fontStyle: 'italic',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '162%',
    marginLeft: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    '@media (max-width: 730px)': {
      display: 'none',
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1px',
      height: '18px',
      backgroundColor: '#828A82',
    }
  },
  loginButton: {
    color: sicrediStyles.primarySicrediDark,
    textTransform: 'capitalize',
    '& .MuiButton-label': {
      fontWeight: 700,
      fontSize: 16,
    },
  },
  loginBox: {
    width: 277,
  },
  container: {
    flex: 'auto',
    [theme.breakpoints.up('lg')]: {
      margin: 'auto',
      maxWidth: '90vw',
    },
  },
}), { name: 'PublicPage' });
